import { useContext } from 'react';
import { MarketContext } from 'context/market';
import MarketElement from './MarketElement';

const MarketPicker: React.FC = () => {
  const { market: selectedMarket, markets, handleMarket } = useContext(MarketContext);

  return (
    <div className="flex justify-between">
      {markets.map((m) => (
        <MarketElement
          key={m.countryCode}
          market={m}
          onClick={handleMarket}
          selected={selectedMarket.countryCode === m.countryCode}
        />
      ))}
    </div>
  );
};

export default MarketPicker;
